export default __webpack_public_path__ + "img/eb20ab7aeb0f328458177d3b6f6477c8.png";